import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dashboard-header-section order-1" }
const _hoisted_2 = { class: "welcome-title fw-bold m-0" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Welcome ")
const _hoisted_4 = { class: "text-capitalize" }
const _hoisted_5 = { class: "dashboard-header-middle-section d-flex flex-row justify-content-between justify-content-sm-center my-md-2 order-3 order-sm-2" }
const _hoisted_6 = {
  key: 0,
  class: "dashboard-weather-vue"
}
const _hoisted_7 = {
  key: 1,
  class: "divider"
}
const _hoisted_8 = { class: "dashboard-date-vue" }
const _hoisted_9 = { class: "dashboard-header-section d-flex flex-wrap gap-4 gap-md-0 justify-content-between justify-content-md-end p-0 order-2 order-sm-3 my-4 my-md-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "Help", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle icon" }, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "Logout", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt icon" }, null, -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeatherReport = _resolveComponent("WeatherReport")!
  const _component_DateTime = _resolveComponent("DateTime")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex flex-column flex-sm-row align-items-center justify-content-between p-0 ps-3 pe-2 pb-3 pb-sm-0 w-100", _ctx.showBorder ? 'dashboard-border-left' : '']),
    id: "DashboardHeader"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.userName), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.hasPlannertaskList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_WeatherReport)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.hasPlannertaskList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_DateTime)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createCommentVNode(" <a class=\"dashboard-menu\">\r\n                <span class=\"text-center\">Search</span>\r\n                <i class=\"fas fa-search icon\"></i>\r\n            </a> "),
      _createElementVNode("a", {
        class: "dashboard-menu-vue",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToHelp()))
      }, _hoisted_12),
      _createElementVNode("a", {
        class: "dashboard-menu-vue",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
      }, _hoisted_15)
    ])
  ], 2 /* CLASS */))
}